<div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fade-in">
    <div class="bg-section w-full max-w-lg rounded-sm overflow-hidden shadow-2xl relative border border-[#E5DDD5]">
        
        <!-- Close Button -->
        <button (click)="closePopup()" class="absolute top-4 right-4 text-muted hover:text-body-text transition-colors z-10">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>

        <div class="p-8">
            <!-- Header -->
            <div class="text-center mb-8">
                <h3 class="font-serif text-2xl text-heading mb-2">Share Your Experience</h3>
                <div class="w-16 h-px bg-btn mx-auto opacity-50"></div>
            </div>

            <!-- Product Info -->
            <div class="flex items-center gap-4 p-4 bg-white border border-[#E5DDD5] rounded-sm mb-8">
                <div class="w-16 h-16 bg-section border border-[#E5DDD5] rounded-sm overflow-hidden flex-shrink-0">
                    <img [src]="product.image || '/assets/placeholder-botanical.jpg'" [alt]="product.name" class="w-full h-full object-cover">
                </div>
                <div>
                    <h4 class="font-serif text-body-text leading-snug">{{ product.name }}</h4>
                    <p class="text-xs text-muted mt-1 italic">Botanical Ritual</p>
                </div>
            </div>

            <!-- Review Form -->
            <form [formGroup]="reviewForm" (ngSubmit)="submitReview()" class="space-y-6">
                
                <!-- Star Rating -->
                <div class="text-center space-y-3">
                    <label class="block text-xs uppercase tracking-widest text-muted">Your Rating</label>
                    <div class="flex justify-center gap-2">
                        <button 
                            type="button"
                            *ngFor="let star of [1,2,3,4,5]" 
                            (click)="setRating(star)"
                            (mouseenter)="setHoverRating(star)"
                            (mouseleave)="setHoverRating(0)"
                            class="text-3xl focus:outline-none transition-transform hover:scale-110 active:scale-95"
                        >
                            <span 
                                [class.text-btn]="star <= (hoverRating || reviewForm.value.rating)"
                                [class.text-[#E5DDD5]]="star > (hoverRating || reviewForm.value.rating)"
                            >★</span>
                        </button>
                    </div>
                    <p *ngIf="reviewForm.get('rating')?.invalid && reviewForm.get('rating')?.touched" class="text-[10px] text-red-600 uppercase tracking-tighter">Please select a rating</p>
                </div>

                <!-- Comment -->
                <div class="space-y-2">
                    <label class="block text-xs uppercase tracking-widest text-muted">Tell us more</label>
                    <textarea 
                        formControlName="comment"
                        rows="4"
                        placeholder="How was your experience with this ritual? (Minimum 10 characters)"
                        class="w-full px-4 py-3 border border-[#E5DDD5] rounded-sm focus:border-btn focus:ring-1 focus:ring-btn outline-none transition-all placeholder:text-[#E5DDD5]/70 bg-white text-body-text"
                    ></textarea>
                    <div class="flex justify-between items-center px-1">
                        <p *ngIf="reviewForm.get('comment')?.invalid && reviewForm.get('comment')?.touched" class="text-[10px] text-red-600 uppercase tracking-tighter">Comment is too short</p>
                        <span class="text-[10px] text-muted ml-auto">{{ reviewForm.get('comment')?.value?.length || 0 }} / 500</span>
                    </div>
                </div>

                <!-- Actions -->
                <div class="pt-4">
                    <button 
                        type="submit"
                        [disabled]="reviewForm.invalid || isSubmitting"
                        class="w-full py-4 bg-btn text-white font-serif uppercase text-xs tracking-widest hover:bg-[#1A2E22] transition-all duration-500 shadow-md flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <span *ngIf="!isSubmitting">Submit Review</span>
                        <div *ngIf="isSubmitting" class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                    </button>
                    <p class="text-center text-[10px] text-muted mt-4 italic uppercase tracking-widest">Your review will be shared after moderation</p>
                </div>

            </form>
        </div>

    </div>
</div>
